import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@klarna/bubble-ui';
import { Message } from 'mage-i18n';
import { connect } from 'react-redux';

import { extractProductNames } from '../selectors/utils';

const ProductIndicator = ({ productNames }) => (
  <div>
    <Typography textToken="text-style/headings/titles/bold/primary">
      <Message path="products-fe.components.steps_headers.product.setup" />
    </Typography>
    <Typography textToken="text-style/text/super-paragraphs/tall/regular">
      {productNames}
    </Typography>
  </div>
);

ProductIndicator.propTypes = {
  productNames: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired, // eslint-disable-line
};

export default connect((state, ownProps) => ({
  productNames: extractProductNames(ownProps.products),
}))(ProductIndicator);
